"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUserInitials = void 0;
const parseUserInitials = (user) => {
    return `${user.first_name.charAt(0).toUpperCase()}${user.last_name.charAt(0).toUpperCase()}`;
};
exports.parseUserInitials = parseUserInitials;
